import React from 'react';
import { Link } from 'react-router-dom';

const generateExternalAddress = (symbol, external, type) => {
  if (symbol === 'BTC' && type === 'Coin') {
    return <td className="keyfield"><a href={`https://blockchain.info/address/${external}`} target='_blank'>{symbol}</a></td>
  } else if (symbol === 'ETH' && type === 'Coin') {
    return <td className="keyfield"><a href={`https://etherscan.io/address/${external}`} target='_blank'>{symbol}</a></td>
  } else {
    return (
      <td>{symbol}</td>
    )
  }
}

const AccountList = props => {
  if (!props.accounts) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.accounts.length === 0) {
    return (
      <div className='empty'>
        No accounts...
      </div>
    );
  }

  return (
    <div>
      <table className="accountsTable">
        <thead>
          <tr>
            <th>type</th>
            <th>currency</th>
            <th>amount</th>
            <th>locked</th>
            <th>key</th>
          </tr>
        </thead>
        <tbody>
          {
            props.accounts.map(account => {
              return (
                <tr key={account.key}>
                  <td>{account.type.replace('Coin','Account')}</td>
                  {generateExternalAddress(account.symbol, account.external, account.type)}
                  <td>{account.amount}</td>
                  <td>{account.amount_locked || 0}</td>
                  <td className="keyfield"><Link to={`/accounts/${account.key}`}>{account.key}</Link></td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default AccountList;



// WEBPACK FOOTER //
// ./src/components/widgets/AccountList.js